// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3q1pg","head":"Table_head__2AWHh","col":"Table_col__qvvTV"};